import React from "react";
import styled from "styled-components";
import MainNav from "../components/navbar/MainNav";
import { motion } from "framer-motion";

export default function Header({ title, description }) {
  return (
    <StyledHeader>
      <MainNav />
      <motion.div 
        className="content"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <motion.h6
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          {title}
        </motion.h6>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          {description}
        </motion.p>
      </motion.div>
    </StyledHeader>
  );
}

const StyledHeader = styled.div`
  min-height: 50vh;
  background: linear-gradient(250.89deg, #b2ebf2 -7.74%, #dcedc8 51.74%);
  padding: 20px 0;
  text-align: center;
  .content {
    padding: 0 20px;
    margin-top: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 14px;
    h6 {
      color: var(--text-light-color);
      font-weight: 1000;
    }
    p {
      max-width: 45ch;
      text-align: center;
    }
  }
`;
